import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { styled } from '@mui/material/styles';
import { PropsWithChildren } from 'react';

import { useLayoutStyle } from 'library/hooks/useLayoutStyle';

import { RedirectCounter } from './RedirectCounter';

export interface ErrorContentProps extends PropsWithChildren {
	title: React.ReactNode;
	subtitle: React.ReactNode;
	description?: React.ReactNode;
	displayRedirect?: boolean;
}

const StyledContainer = styled('div')({
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'center',
	textAlign: 'center',
});

export const ErrorContent = ({
	children,
	title,
	subtitle,
	description,
	displayRedirect = true,
}: ErrorContentProps): React.JSX.Element => {
	const { minHeight: height } = useLayoutStyle();

	return (
		<StyledContainer sx={{ height }}>
			<div className="alert alert-danger" role="alert">
				<ReportProblemIcon fontSize="large" />
				<h2 className="alert-heading">{title}</h2>
				<p>{subtitle}</p>
				{description && (
					<>
						<hr />
						<p className="mb-0">{description}</p>
					</>
				)}
				{children}
				{displayRedirect && <RedirectCounter />}
			</div>
		</StyledContainer>
	);
};
